import { useEffect, useMemo, useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { useTheme } from '@emotion/react'
import { Provenance, Practitioner } from 'fhir/r4'
import { getProvenanceData } from '../../patients/utils'
import { ProvenanceData } from '../../patients/patientsSlice'
import { ColDef, INumberFilterParams } from 'ag-grid-community'
import { toast } from 'react-toastify'
import MedAgDataGrid from '../../../components/MedAgDataGrid'
import { startSxpProxy } from '../../../utils/api'
import {
  ADMIN_PROJECT_ID,
  REGISTRATION_PROJECT_ID,
} from '../../../utils/constants'

import useCustomStyles from '../../../utils/hooks/CustomStylesHook'
import {
  AddRoles,
  CreatePartnerForm,
  Edit,
  forms,
  UserManagementIntent,
  UserManagementMessages,
  ViewRoles,
  formValues,
  Remove,
} from '../constants'
import UserData from './UserData'
import ProvenanceView from '../../../components/ProvenanceView'
import KeycloakService from '../../../utils/keycloakService'
import { SUPER_ADMIN_DELETE } from '../../../utils/roles'
import { selectLocations } from '../../location/locationSlice'
import { useAppSelector } from '../../../app/hooks'
import { PractitionerOption } from './UserForm'
import KeycloakRolesDialog from './KeyclockRoles'
import { useNavigate } from 'react-router-dom'
import { PageSize } from '../../appointments/models'
import {
  Create,
  KEYCLOCK_ROLES,
  USER_CREATATION,
} from '../../bedManagement/endpoints/EndPoints'
import { activeText, inactiveText } from '../../Radiology/Constants/constants'
import CustomHeader from '../../Radiology/components/RadiologyModel/CustomHeader'
import { Cancel } from '../../AB Membership/constants'

const styles = () => ({
  proRithmDasboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    padding: '2%',
    gap: 20,
  },
  proRithmDasboardTableContainer: {
    width: '100%',
    height: '100%',
  },
  proRithmDasboardheading: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  proRithmDasboardCreateBtn: {
    textTransform: 'capitalize',
    backgroundColor: '#4682b4',
  },
  deviceText: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  centerHeader: {
    color: '#ffffff',
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
})

const NewUserDataTable = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [showOperatingUnit, setShowOperatingUnit] = useState(false)
  const [provenances, setProvenances] = useState<
    Record<string, ProvenanceData>
  >({})
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [usersData, setUsersData] = useState<UserData[]>([])
  const [odooUser, setOdooUser] = useState<any[]>([])
  const [fhirUser, setFhirUser] = useState<any[]>([])
  const [patientIds, setPatientIds] = useState<string[]>([])
  const [selectedUserId, setSelectedUserId] = useState<any>('')
  const [selectedCheckbox, setSelectedCheckbox] = useState<any>(null)
  const [selectedUserData, setSelectedUserData] = useState<any>(null)
  const [keycloakRoles, setKeycloakRoles] = useState<PractitionerOption[]>([])
  const [keycloakGroupRoles, setKeycloakGroupRoles] = useState<
    PractitionerOption[]
  >([])
  const [isGroup, setIsGroup] = useState<boolean>(false)
  const [rolesopen, setRolesOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState<UserData | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [operatingUnit, setOperatingUnit] = useState<string[]>([])
  const locations = useAppSelector(selectLocations)
  const [operatingUnitId] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [selectedAssignedLocationId, setSelectedAssignedLocationId] = useState<
    any[]
  >([])
  const [selectedLocations, setSelectedLocations] = useState<any[]>([])
  const [editUserData, setEditUserData] = useState<{
    email: string
    firstName: string
    lastName: string
  }>({
    email: '',
    firstName: '',
    lastName: '',
  })

  const handleModalClose = () => {
    setIsModalOpen(false)
    setSelectedUser(null)
  }
  const handleCloseDialog = () => {
    setRolesOpen(false)
    setIsGroup(false)
  }
  const handlePasswordReset = () => {
    if (newPassword !== confirmPassword) {
      alert(UserManagementMessages?.PasswordIncorrect)
      return
    }
    const odooUsera = odooUser?.find(
      (user: any) =>
        user?.name?.toLowerCase() === selectedUser?.username?.toLowerCase()
    )
    startSxpProxy(ADMIN_PROJECT_ID, UserManagementIntent?.passwordReset, {
      userId: selectedUser?.id,
      value: newPassword,
      odooId: odooUsera?.id,
      name: odooUsera?.name,
      SelectedLocation: operatingUnitId,
    })
      ?.then((data) => {
        if (data?.status === 200) {
          toast?.success(UserManagementMessages?.Done)
        }
      })
      .catch((err) => console.error(UserManagementMessages?.ResetErrorMsg, err))

    setNewPassword('')
    setConfirmPassword('')
    setIsModalOpen(false)
    setSelectedUser(null)
  }

  const handleChangeStatus = (
    userId: string,
    username: string,
    active: boolean
  ) => {
    const odooUsera = odooUser?.find(
      (user: any) => user?.name?.toLowerCase() === username?.toLowerCase()
    )
    startSxpProxy(ADMIN_PROJECT_ID, UserManagementIntent?.inactiveUser, {
      userId,
      username,
      active,
      name: odooUsera?.name,
      odooId: odooUsera?.id,
      SelectedLocation: operatingUnitId,
    })
      ?.then(() => {
        fetchUsers()
      })
      ?.catch((err) => console.error(UserManagementMessages?.EditErrorMsg, err))
  }
  const handleGetAssignedLocation = (keyclockId: any) => {
    setSelectedUserId(keyclockId)
    startSxpProxy(
      ADMIN_PROJECT_ID,
      UserManagementIntent?.UserAssignedLocation,
      {
        keyclockId,
      }
    )
      ?.then((response) => {
        let operatingUnitIds = response?.data?.data?.attributes?.location || []
        if (
          Array?.isArray(operatingUnitIds) &&
          operatingUnitIds?.length === 1
        ) {
          operatingUnitIds = operatingUnitIds?.[0]
            ?.split(',')
            ?.map((id: any) => id?.trim())
        }
        if (Array?.isArray(operatingUnitIds) && operatingUnitIds?.length > 0) {
          const matchingLocations = operatingUnitIds
            ?.map((id) =>
              locations?.find((loc: any) => loc?.resource?.id === id)
            )
            ?.filter(Boolean)

          if (matchingLocations?.length > 0) {
            setOperatingUnit(
              matchingLocations?.map((loc: any) => loc?.resource?.name)
            )
          } else {
            setOperatingUnit([UserManagementMessages?.NoMatchLoc])
          }
        } else {
          setOperatingUnit([UserManagementMessages?.noLocation])
        }
        setShowOperatingUnit(true)
      })
      .catch((err) =>
        console.error(UserManagementMessages?.KeylockRoleErrorMsg, err)
      )
  }
  const renderStatusSelect = (user: UserData) => {
    return (
      <select
        className='medication-input w75'
        value={user.enabled ? activeText : inactiveText}
        onChange={(e) =>
          handleChangeStatus(
            user?.id,
            user?.username,
            e.target.value === activeText
          )
        }
      >
        <option value={activeText}>{forms?.active}</option>
        <option value={inactiveText}>{forms?.inactive}</option>
      </select>
    )
  }
  const RenderActions = (params: any) => {
    const user = params.data

    return <div>{renderStatusSelect(user)}</div>
  }

  const isCheckboxChecked = (userId: any) => {
    fhirUser?.forEach((id) => {
      const phoneTelecoms = id?.resource?.telecom?.filter(
        (d: any) => d?.system === CreatePartnerForm?.phone
      )
      console.log(CreatePartnerForm?.PhoneTelecom, phoneTelecoms?.[0]?.value)
    })

    return fhirUser?.some(
      (id) => id?.resource?.identifier?.[1]?.value === userId
    )
  }

  const handleKeycloakRoleClick = (userId: any) => {
    setSelectedUserId(userId)
    startSxpProxy(
      ADMIN_PROJECT_ID,
      UserManagementIntent?.keyclockCompositeRoles,
      { userId }
    )
      ?.then((response) => {
        if (response?.data) {
          setKeycloakRoles(
            Array?.isArray(response?.data?.data) ? response?.data?.data : []
          )
          setRolesOpen(true)
        }
      })
      .catch((err) =>
        console.error(UserManagementMessages?.KeylockRoleErrorMsg, err)
      )
  }
  const handleKeycloakGroupRoleClick = (userId: any) => {
    setSelectedUserId(userId)
    setIsGroup(true)
    startSxpProxy(ADMIN_PROJECT_ID, UserManagementIntent?.GetUserGroupRoles, {
      userId,
    })
      ?.then((response) => {
        if (response?.data) {
          setKeycloakGroupRoles(response?.data)
          setRolesOpen(true)
        }
      })
      .catch((err) =>
        console.error(UserManagementMessages?.KeylockRoleErrorMsg, err)
      )
  }

  function convertTimestamp(timestamp: any) {
    const date = new Date(timestamp)
    return date?.toLocaleString()
  }

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    user: any
  ) => {
    setSelectedCheckbox(event.target.checked ? user?.id : null)
    setSelectedUserData(event.target.checked ? user : null)
  }
  const columnDefs: ColDef[] = [
    {
      headerName: '',
      field: 'checkbox',
      width: 50,
      sortable: false,
      filter: false,
      checkboxSelection: false,
      cellRenderer: (params: any) => {
        return (
          <input
            style={{ height: '10px', width: '10px' }}
            type='checkbox'
            checked={selectedCheckbox === params?.data?.id}
            onChange={(event) => handleCheckboxChange(event, params?.data)}
          />
        )
      },
      headerClass: classes?.checkBox,
      cellClass: classes?.checkBox,
    },
    {
      headerName: 'Id',
      valueGetter: (params: any) => {
        return params.node ? params.node.rowIndex + 1 : null
      },
      width: 80,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'UserName',
      field: 'username',
      width: 120,
      sortable: true,
      filter: true,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      filterParams: {
        buttons: ['clear'],
        closeOnApply: true,
      } as INumberFilterParams,
      headerComponent: CustomHeader,
    },
    {
      headerName: 'Keyclock Id',
      field: 'id',
      width: 150,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      filterParams: {
        buttons: ['clear'],
        closeOnApply: true,
      } as INumberFilterParams,
      headerComponent: CustomHeader,
    },
    {
      headerName: 'Name',
      valueGetter: (params) =>
        `${params.data.firstName || ''} ${params.data.lastName || ''}`,
      width: 150,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      filterParams: {
        buttons: ['clear'],
        closeOnApply: true,
      } as INumberFilterParams,
      headerComponent: CustomHeader,
    },
    {
      headerName: 'Email.Id	',
      field: 'email',
      width: 150,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      filterParams: {
        buttons: ['clear'],
        closeOnApply: true,
      } as INumberFilterParams,
      headerComponent: CustomHeader,
    },
    {
      headerName: 'Phone No',
      field: 'phoneNumber',
      width: 150,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      filterParams: {
        buttons: ['clear'],
        closeOnApply: true,
      } as INumberFilterParams,
      headerComponent: CustomHeader,
    },

    {
      headerName: 'Operating Unit',
      field: 'OperatingUnit',
      width: 150,
      sortable: false,
      filter: false,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      cellRenderer: (params: any) => {
        return (
          <a
            className='view-visit-button'
            onClick={() => handleGetAssignedLocation(params?.data?.id)}
          >
            View
          </a>
        )
      },
    },
    {
      headerName: 'Group Roles',
      field: 'Roles',
      width: 80,
      sortable: false,
      filter: false,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      cellRenderer: (params: any) => (
        <a
          className='view-visit-button'
          onClick={() => handleKeycloakGroupRoleClick(params?.data?.id)}
        >
          View
        </a>
      ),
    },
    {
      headerName: 'Roles',
      field: 'Roles',
      width: 80,
      sortable: false,
      filter: false,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      cellRenderer: (params: any) => (
        <a
          className='view-visit-button'
          onClick={() => handleKeycloakRoleClick(params?.data?.id)}
        >
          View
        </a>
      ),
    },
    {
      headerName: 'Reset Pwd',
      field: 'reset',
      width: 120,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      filterParams: {
        buttons: ['clear'],
        closeOnApply: true,
      } as INumberFilterParams,
      cellRenderer: (params: any) => {
        return (
          <button
            className='view-visit-button'
            onClick={() => {
              setSelectedUser(params.data)
              setIsModalOpen(true)
            }}
            disabled={!KeycloakService?.hasRole([SUPER_ADMIN_DELETE])}
          >
            Reset
          </button>
        )
      },
      headerComponent: CustomHeader,
    },

    {
      headerName: 'Created',
      field: 'createdOn',
      width: 150,
      sortable: true,
      filter: 'agDateColumnFilter',
      cellRenderer: (params: any) => {
        const convertedTimestamp = convertTimestamp(
          params.data?.createdTimestamp
        )
        return <span className='UserDate'>{convertedTimestamp}</span>
      },
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      headerComponent: CustomHeader,
    },
    {
      headerName: 'Updated',
      field: 'updatedOn',
      width: 150,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => {
        const fhirId = params?.data?.fhirId

        const createdOn = provenances?.[fhirId]?.createdOn
        const updatedOn = provenances?.[fhirId]?.updatedOn
        const createdBy = provenances?.[fhirId]?.createdBy
        const updatedBy = provenances?.[fhirId]?.updatedBy
        return (
          <div>
            <ProvenanceView
              date={updatedOn ?? createdOn}
              name={updatedBy ?? createdBy}
              mode={'UPDATE'}
            />
          </div>
        )
      },
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      filterParams: {
        buttons: ['clear'],
        closeOnApply: true,
      } as INumberFilterParams,
      headerComponent: CustomHeader,
    },
    {
      headerName: 'Thop',
      field: 'thopStatus',
      width: 150,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => {
        const isChecked = params.value == true
        return (
          <input
            type='checkbox'
            checked={isChecked}
            onChange={() => isCheckboxChecked(params)}
          />
        )
      },
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      filterParams: {
        buttons: ['clear'],
        closeOnApply: true,
      },
      headerComponent: CustomHeader,
    },

    {
      headerName: 'Odoo',
      field: 'odooStatus',
      width: 150,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => {
        const isChecked = params.value == true
        return (
          <input
            type='checkbox'
            checked={isChecked}
            onChange={() => isCheckboxChecked(params)}
          />
        )
      },
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      filterParams: {
        buttons: ['clear'],
        closeOnApply: true,
      },
      headerComponent: CustomHeader,
    },
    {
      headerName: 'Status',
      field: 'actions',
      width: 100,
      sortable: false,
      filter: false,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      cellRenderer: RenderActions,
      headerComponent: CustomHeader,
    },
  ]
  const handleSubmitEditedData = () => {
    startSxpProxy(ADMIN_PROJECT_ID, UserManagementIntent?.updatedataKeyclock, {
      email: editUserData?.email,
      firstName: editUserData?.firstName,
      lastName: editUserData?.lastName,
      userid: selectedUserId,
    })
      ?.then((response) => {
        if (response?.data) {
          setKeycloakRoles(
            Array?.isArray(response?.data?.data) ? response?.data?.data : []
          )
          fetchUsers()
          setEditDialogOpen(false)
          toast.success(UserManagementMessages?.UserCreatedMsg)
        }
      })
      .catch((err) => {
        console.log(err)
        toast.error(UserManagementMessages?.UserErrorMsg)
      })
  }

  const handleEdit = (user: UserData) => {
    setEditDialogOpen(true)
    setEditUserData({
      email: user?.email || 'N/A',
      firstName: user?.firstName || 'N/A',
      lastName: user?.lastName || 'N/A',
    })
    setSelectedUserId(user?.id)
  }
  const navigate = useNavigate()

  const handleCreateUser = () => {
    navigate(USER_CREATATION)
  }
  const viewRoles = () => {
    navigate(KEYCLOCK_ROLES)
  }
  const FilterActions = () => {
    return (
      <>
        <Button
          variant='contained'
          size='small'
          className={classes?.proRithmDasboardCreateBtn}
          onClick={() => handleEdit(selectedUserData)}
          disabled={!selectedCheckbox}
        >
          {Edit}
        </Button>
        <Button
          variant='contained'
          size='small'
          className={classes?.proRithmDasboardCreateBtn}
          onClick={() => handleCreateUser()}
        >
          {Create}
        </Button>
        <Button
          variant='contained'
          size='small'
          className={classes?.proRithmDasboardCreateBtn}
          onClick={() => viewRoles()}
        >
          {ViewRoles}
        </Button>
      </>
    )
  }

  useEffect(() => {
    fetchUsers()
    getOdooUsers()
    getFhirUsers()
  }, [])

  const fetchUsers = () => {
    startSxpProxy(ADMIN_PROJECT_ID, UserManagementIntent?.KeyclockUsers)
      ?.then((response) => {
        const data = response?.data?.data
        setUsersData(data)
      })
      .catch((err) => console?.error(UserManagementMessages?.Fetchusers, err))
  }

  const getOdooUsers = () => {
    startSxpProxy(ADMIN_PROJECT_ID, UserManagementIntent?.getOdooUsers, {})
      ?.then((response) => {
        const data = response?.data
        setOdooUser(data)
      })
      .catch((err) =>
        console.error(UserManagementMessages?.FetchOdooUsers, err)
      )
  }

  const getFhirUsers = () => {
    startSxpProxy(ADMIN_PROJECT_ID, UserManagementIntent?.getfhirUsers)
      ?.then((response) => {
        const data = response?.data?.entry
        setFhirUser(data)
      })
      .catch((err) =>
        console.error(UserManagementMessages?.FetchFhirUsers, err)
      )
  }

  const fetchAndSetProvenances = async (patientIds: string[]) => {
    if (!patientIds?.length) return // Early exit if no patient IDs are present.

    try {
      const patientIdsString = patientIds.join(',')

      const response = await startSxpProxy(
        REGISTRATION_PROJECT_ID,
        UserManagementIntent?.fetchProvenance,
        { patientIds: patientIdsString }
      )

      const entries =
        response?.data?.entry?.map(
          ({ resource }: { resource: Provenance | Practitioner }) => resource
        ) ?? []

      const provenanceData = getProvenanceData(entries)
      setProvenances(provenanceData)
    } catch (error) {
      console.error(UserManagementMessages?.ProvenanceDataErrorMsg, error)
      toast.error(UserManagementMessages?.ProvenanceDataErrorMsg) // Show user-friendly error.
    }
  }

  useEffect(() => {
    fetchAndSetProvenances(patientIds)
  }, [patientIds])

  const matchedUsers = useMemo(() => {
    const matchedUsersList = usersData?.filter((user) =>
      fhirUser?.some(
        (fUser) => fUser?.resource?.identifier?.[1]?.value === user?.id
      )
    )
    const matchedPatientIds = fhirUser
      ?.filter((fUser) =>
        matchedUsersList?.some(
          (user) => fUser?.resource?.identifier?.[1]?.value === user?.id
        )
      )
      ?.map((fUser) => fUser?.resource?.id)
      ?.filter((id) => id !== undefined)

    setPatientIds(matchedPatientIds)
    return matchedUsersList
  }, [usersData, fhirUser])

  const combinedUsersData = useMemo(() => {
    if (!usersData || !fhirUser || !odooUser) {
      return []
    }
    return (
      matchedUsers?.map((user) => {
        const fhirUserData = fhirUser?.find(
          (fUser) => fUser?.resource?.identifier?.[1]?.value === user?.id
        )
        const odooUserData = odooUser?.find(
          (oUser) => oUser?.oauth_uid === user?.id
        )

        const phoneNumber = fhirUserData?.resource?.telecom
          ?.filter((d: any) => d?.system === CreatePartnerForm?.phone)
          ?.map((phone: any) => phone?.value)[0]
        const thopStatus = fhirUser?.some(
          (fUser) => fUser?.resource?.identifier?.[1]?.value === user?.id
        )
        const OdooStatus = odooUser?.some((ou) => ou?.oauth_uid === user?.id)
        const fhirId = fhirUserData?.resource?.id || 'N/A'
        const createdOn = provenances?.[fhirId]?.createdOn || 'N/A'
        const updatedOn = provenances?.[fhirId]?.updatedOn || 'N/A'
        const createdBy = provenances?.[fhirId]?.createdBy || 'N/A'
        const updatedBy = provenances?.[fhirId]?.updatedBy || 'N/A'
        return {
          ...user,
          phoneNumber: phoneNumber || 'N/A',
          firstName: fhirUserData?.resource?.name?.[0]?.given?.[0] || 'N/A',
          lastName: fhirUserData?.resource?.name?.[0]?.family || 'N/A',
          fhirId: fhirUserData?.resource?.id || 'N/A',
          odooRole: odooUserData?.role || 'N/A',
          odooStatus: OdooStatus || 'N/A',
          thopStatus: thopStatus || 'N/A',
          createdOn,
          updatedOn,
          createdBy,
          updatedBy,
        }
      }) || []
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fhirUser, odooUser, usersData])
  const [locationsData, setLocations] = useState<
    { id: string | undefined; name: string | undefined }[]
  >([])
  useEffect(() => {
    const activeLocations =
      locations
        ?.map(({ resource }) => ({
          id: resource?.id,
          name: resource?.name,
          status: resource?.status,
        }))
        ?.filter((location: any) => location?.status === formValues?.active) ||
      []

    setLocations(activeLocations)
  }, [locations])

  const handleLocationChange = (id: string) => {
    setSelectedLocations((prev: string[]) => {
      const isAlreadySelected = prev?.includes(id)
      return isAlreadySelected
        ? prev?.filter((locId) => locId !== id)
        : [...prev, id]
    })
  }

  const getAssignedLocationIds = () => {
    return (operatingUnit || [])
      ?.map((assignedName: string) => {
        const match = locationsData?.find(
          (loc: any) => loc?.name === assignedName
        )
        return match?.id
      })
      ?.filter((id): id is string => !!id?.trim())
  }

  const sendLocationUpdate = async (
    locationIds: string[],
    successMsg: string,
    errorMsg: string
  ) => {
    const payload = {
      keycloakId: selectedUserId,
      location: [locationIds?.join(',')],
    }
    try {
      const response = await startSxpProxy(
        ADMIN_PROJECT_ID,
        UserManagementIntent?.AddMultiLoc,
        payload
      )
      if (response?.status === 200 || response?.status === 204) {
        toast.success(successMsg)
        setSelectedLocations([])
        setShowOperatingUnit(false)
      } else {
        toast.error(errorMsg)
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const handleAddMultiLoc = async () => {
    if (!selectedLocations || selectedLocations?.length === 0) return
    const allSelected = Array.from(
      new Set([...getAssignedLocationIds(), ...selectedLocations])
    )
    await sendLocationUpdate(
      allSelected,
      UserManagementMessages?.LocAddSuccess,
      UserManagementMessages?.LocAddFailedMSg
    )
  }

  const handleRemoveAssignedLoc = async () => {
    if (!selectedAssignedLocationId || selectedAssignedLocationId?.length === 0)
      return
    const updatedAssigned = getAssignedLocationIds()?.filter(
      (id) => !selectedAssignedLocationId?.includes(id)
    )
    setSelectedAssignedLocationId([])
    await sendLocationUpdate(
      updatedAssigned,
      UserManagementMessages?.LocRemoveSuccess,
      UserManagementMessages?.LocRemoveFailedMsg
    )
  }

  const assignedLocationIds =
    locationsData
      ?.filter((location: any) => operatingUnit?.includes(location?.name))
      ?.map((location: any) => location?.id) || []

  const availableLocations =
    locationsData?.filter(
      (location: any) => !assignedLocationIds?.includes(location?.id)
    ) || []

  const handleAssignedLocationClick = (locationId: any) => {
    setSelectedAssignedLocationId((prev: string[]) =>
      prev?.includes(locationId)
        ? prev?.filter((id) => id !== locationId)
        : [...prev, locationId]
    )
  }
  const cancelButton = () => {
    setShowOperatingUnit(false)
    setSelectedAssignedLocationId([])
    setSelectedLocations([])
  }

  return (
    <Box height={'93%'} width={'100%'}>
      <Box
        className={classes?.proRithmDasboardContainer}
        height={'100%'}
        width={'100%'}
      >
        <Box
          className={classes?.proRithmDasboardTableContainer}
          height={'100%'}
          width={'100%'}
        >
          <MedAgDataGrid
            tableHeading='Users'
            tableHeight={'100%'}
            rowData={combinedUsersData}
            columnDefs={columnDefs}
            pagination={false}
            pageSizeOptions={PageSize}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            headerHeight={30}
            filterActions={<FilterActions />}
            searchFieldWidth={200}
          />
        </Box>
        <Dialog
          open={showOperatingUnit}
          onClose={() => setShowOperatingUnit(false)}
        >
          <DialogContent className='DialogWidth'>
            <h3 className='rolestitlefontsize'>
              {UserManagementMessages?.OperatingUnit}
            </h3>
            <div className='role-list-container'>
              <h3 className='rolestitlefontsize'>Assigned Locations</h3>
              <ul className='rolestitlefontsize'>
                {operatingUnit?.length > 0 ? (
                  operatingUnit?.map((unit: any, index: number) => {
                    const matchedLoc = locationsData?.find(
                      (loc: any) => loc?.name === unit
                    )
                    const locationId = matchedLoc?.id
                    return (
                      <li key={index} className='location-item'>
                        <Checkbox
                          className='checkboxsize'
                          checked={selectedAssignedLocationId?.includes(
                            locationId
                          )}
                          onChange={() =>
                            handleAssignedLocationClick(locationId)
                          }
                        />
                        {unit}
                      </li>
                    )
                  })
                ) : (
                  <li>No assigned locations</li>
                )}
              </ul>
              {availableLocations?.length > 0 && (
                <div>
                  <h3 className='rolestitlefontsize'>Available Locations</h3>
                  <div className='role-list rolestitlefontsize'>
                    <ul className='rolesfontsize'>
                      {availableLocations?.map((location: any) => (
                        <li key={location?.id} className='location-item'>
                          <Checkbox
                            className='checkboxsize'
                            checked={selectedLocations?.includes(location?.id)}
                            onChange={() => handleLocationChange(location?.id)}
                          />
                          {location?.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>

            <div className='dialogbutton fixed-buttons'>
              <Button
                className={classes?.proRithmDasboardCreateBtn}
                variant='contained'
                size='small'
                disabled={selectedLocations?.length === 0}
                onClick={handleAddMultiLoc}
              >
                {AddRoles}
              </Button>
              <Button
                className={classes?.proRithmDasboardCreateBtn}
                variant='contained'
                size='small'
                disabled={selectedAssignedLocationId?.length === 0}
                onClick={handleRemoveAssignedLoc}
              >
                {Remove}
              </Button>
              <Button
                className={classes?.proRithmDasboardCreateBtn}
                onClick={() => cancelButton()}
                variant='contained'
                size='small'
              >
                {Cancel}
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog open={isModalOpen} onClose={handleModalClose}>
          <DialogTitle>{UserManagementMessages?.ResetPswd}</DialogTitle>
          <DialogContent>
            <form
              onSubmit={(e) => {
                e.preventDefault()
                handlePasswordReset()
              }}
            >
              <TextField
                label='New Password'
                type='password'
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                fullWidth
                margin='normal'
              />
              <TextField
                label='Confirm Password'
                type='password'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                fullWidth
                margin='normal'
              />
              <div className='editSubmitCancelBtn'>
                <button type='submit' className='userform-submit-btn'>
                  Submit
                </button>
                <button
                  className='userform-submit-btn'
                  onClick={handleModalClose}
                >
                  Cancel
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)}>
          <DialogTitle>Edit</DialogTitle>
          <DialogContent>
            <form
              onSubmit={(e) => {
                e.preventDefault()
              }}
            >
              <TextField
                label='Email'
                type='text'
                value={editUserData?.email}
                onChange={(e) =>
                  setEditUserData((prevState) => ({
                    ...prevState,
                    email: e.target.value,
                  }))
                }
                fullWidth
                margin='normal'
              />
              <TextField
                label='First Name'
                type='text'
                value={editUserData?.firstName}
                onChange={(e) =>
                  setEditUserData((prevState) => ({
                    ...prevState,
                    firstName: e.target.value,
                  }))
                }
                fullWidth
                margin='normal'
              />
              <TextField
                label='Last Name'
                type='text'
                value={editUserData?.lastName}
                onChange={(e) =>
                  setEditUserData((prevState) => ({
                    ...prevState,
                    lastName: e.target.value,
                  }))
                }
                fullWidth
                margin='normal'
              />
              <div className='editSubmitCancelBtn'>
                <button
                  type='submit'
                  className='userform-submit-btn '
                  onClick={() => handleSubmitEditedData()}
                >
                  Submit
                </button>
                <button
                  className='userform-submit-btn'
                  onClick={() => setEditDialogOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <KeycloakRolesDialog
          isOpen={rolesopen}
          onClose={handleCloseDialog}
          roles={keycloakRoles}
          grouproles={keycloakGroupRoles}
          userId={selectedUserId}
          isGroup={isGroup}
        />
      </Box>
    </Box>
  )
}

export default NewUserDataTable
